/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from "@ember/object";
import { tracked } from "@glimmer/tracking";

import journalEventRetrievalStrategies from "parog-web/components/forc/utils/journal-event-retrieval-strategies";
import type { Question } from "parog-web/models/ctcae-filled-journal-event";
import CtcaeFilledJournalEvent from "parog-web/models/ctcae-filled-journal-event";
import CtcaeBaseForm from "../base-form";

export default class CtcaeConsultForm extends CtcaeBaseForm {
  static fullComponentId = "ctcae/consult-form";
  static forcDisplayName = "Questionnaire de suivi";

  retrieveJournalEvent = journalEventRetrievalStrategies.sourceJournalEvent;

  static journalEventClass = CtcaeFilledJournalEvent;

  @tracked notChanged = true;

  @action
  typeToAnswers(type: string) {
    return CtcaeFilledJournalEvent.typeToValue(type);
  }

  @action
  onChange(question: Question, value: string) {
    question.answer = value;
    this.notChanged = false;
  }
}
